module.exports = __webpack_public_path__ + "media/src/assets/Images/Hamburger-f9057ce91c04e17a8d34a581df1e234a.svg";